<template>
  <a-modal
    title="触发条件"
    :visible="visible"
    :centered="true"
    :mask-closable="false"
    :width="742"
    wrap-class-name="trigger-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form
      ref="form"
      :form="form"
      class="trigger-form clearfix"
    >
      <label class="left">条件：</label>
      <div class="right">
        <a-radio-group
          v-model="formData.type"
          :options="plainOptions"
          @change="onChangeType"
        />
        <ul class="list">
          <li
            v-for="(row, i) in formData.list"
            :key="row._id"
            class="item clearfix"
          >
            <a-form-item class="fieldkey fl">
              <!-- 选择字段 -->
              <div
                v-decorator="[`fieldkey${row._id}`, {
                  rules: [{
                    required: true, message: '请选择'
                  }],
                  initialValue: row.fieldkey
                }]"
              >
                <a-select
                  :default-value="row.fieldkey"
                  :show-search="true"
                  :filter-option="filterOption"
                  :get-popup-container="
                    triggerNode => {
                      return triggerNode.parentNode || document.body;
                    }
                  "
                  dropdown-class-name="tigger-condition-select"
                  placeholder="请选择"
                  @change="handleChangeFieldtype($event, i, row)"
                >
                  <a-select-opt-group
                    v-for="modules in row.selectOptions"
                    :key="modules.fieldkey"
                  >
                    <span
                      v-if="modules.fieldname"
                      slot="label"
                    >{{ modules.fieldname }}</span>
                    <a-select-option
                      v-for="field in modules.child"
                      :key="field.fieldkey"
                      :value="modules.fieldkey + '.' + field.fieldkey"
                    >
                      {{ field.fieldname }}<span v-if="field.fieldtype_desc">[{{ field.fieldtype_desc }}]</span>
                    </a-select-option>
                  </a-select-opt-group>
                </a-select>
              </div>
            </a-form-item>

            <!-- 选择关系 :value="row.typevalue"-->
            <a-form-item class="relate fl">
              <a-select
                v-decorator="[`typevalue${row._id}`, {
                  rules: [{
                    required: true, message: '请选择'
                  }],
                  initialValue: row.typevalue
                }]"
                :get-popup-container="
                  triggerNode => {
                    return triggerNode.parentNode || document.body;
                  }
                "
                placeholder="请选择"
                @change="handleChangeRelate($event, i, row)"
              >
                <a-select-option
                  v-for="item in row.optionstype"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              :validate-status="row.validateStatus ? 'error' : ''"
              :help="row.validateStatus && setFieldValuePlaceholder(row)"
              class="value-box fl clearfix"
            >
              <field-item
                :id="`${row.fieldkey}${row._id}`"
                class="fl clearfix"
                :data="row.currField"
                :value="row.fieldvalue"
                :typevalue="row.typevalue"
                @change="handleChangeItem($event, i, row)"
              />
            </a-form-item>
            <i
              v-if="formData.list.length > 1"
              class="fs-blue fl del-btn"
              @click="handleDelItem(i, row)"
            >删除</i>
          </li>
        </ul>
        <a
          class="fs-blue add-btn"
          @click="handleAdd"
        ><i class="iconfont iconicon-test10" />添加条件</a>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import FieldItem from './TriggerItem'

export default {
  name: 'TriggerMoadl',
  components: {
    FieldItem
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    emailid: {
      type: [Number, String],
      default: ''
    },
    triggertype: {
      type: Number,
      default: 1
    },
    triggerCondition: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    let type = this.triggertype
    return {
      form: this.$form.createForm(this),
      plainOptions: [
        { label: '符合所有', value: 1 },
        { label: '符合任意一项', value: 2 }
      ],
      formData: {
        type,
        list: []
      }
    }
  },
  provide () {
    return {
      myForm: this.form
    }
  },

  computed: {
    newObj () {
      let { allConfig = {} } = this.triggerCondition
      let newObj = {
        selectOptions: allConfig,
        currField: {
          fieldtype: 'text',
          placeholder: '请输入',
          disabled: false,
          validateStatus: false
        },
        fieldkey: undefined,
        fieldtype: 'text',
        options: [],
        optionstype: [],
        fieldvalue: '',
        typevalue: undefined
      }
      return newObj
    }
  },

  watch: {
    visible (val) {
      if (val) {
        this.formData.type = this.triggertype
        this.setData()
      }
    }
  },

  methods: {
    setData () {
      let { config = [], allConfig = {} } = this.triggerCondition || {}
      if (typeof config === 'string' || !config) {
        config = []
      }

      if (!config.length) {
        let addObj = JSON.parse(JSON.stringify(this.newObj))

        addObj._id = Math.random() * Math.pow(10, 17)

        config.push(addObj)
      }

      for (let i in config) {
        let triggerItem = config[i]
        for (let k in allConfig) {
          let parent = allConfig[k]
          for (let j in parent.child) {
            let child = parent.child[j]
            if (parent.fieldkey + '.' + child.fieldkey === triggerItem.fieldkey) {
              if (triggerItem.fieldtype === 'radioinfo_level') {
                let { fieldconfig = {} } = child
                child.options = this.LevelOption(child.options, fieldconfig)
                child.fieldvalue = triggerItem.fieldvalue
              } else if (triggerItem.fieldtype === 'number' && this.$toType(triggerItem.fieldvalue) === 'array') {
                child.fieldvalue = {} // min max
                child.fieldvalue.min = triggerItem.fieldvalue[0]
                child.fieldvalue.max = triggerItem.fieldvalue[1]
              } else if (triggerItem.fieldtype === 'datetime' && this.$toType(triggerItem.fieldvalue) === 'array') {
                child.fieldvalue = {} // starttime endtime
                child.fieldvalue.starttime = triggerItem.fieldvalue[0]
                child.fieldvalue.endtime = triggerItem.fieldvalue[1]
              } else {
                child.fieldvalue = triggerItem.fieldvalue
              }

              let obj = {
                _id: config[i]._id,
                selectOptions: allConfig,
                currField: JSON.parse(JSON.stringify(child)),
                fieldkey: parent.fieldkey + '.' + child.fieldkey,
                fieldtype: child.fieldtype,
                fieldname: child.fieldname,
                options: child.options,
                optionstype: child.optionstype,
                fieldvalue: child.fieldvalue,
                typevalue: triggerItem.typevalue
              }

              if (triggerItem.typevalue === '已填写' || triggerItem.typevalue === '未填写') {
                obj.currField.disabled = true
              } else {
                obj.currField.disabled = false
              }
              obj.validateStatus = false

              config.splice(i, 1, obj)
            }
          }
        }
      }

      this.formData.list = config
    },

    onChangeType (e) {
      let val = e.target.value
      this.formData.type = val
    },

    handleChangeFieldtype (value, index, row) {
      row.fieldkey = value
      row.currField = {}
      row.typevalue = ''
      row.fieldvalue = ''

      for (let k in row.selectOptions) {
        for (let j in row.selectOptions[k].child) {
          let field = row.selectOptions[k].child[j]
          if (k + '.' + field.fieldkey === value) {
            field.fieldvalue = ''
            field.validateStatus = false
            row.currField = field
            row.fieldtype = field.fieldtype
            row.fieldname = field.fieldname
            row.options = field.options
            row.optionstype = field.optionstype

            if (row.fieldtype === 'radioinfo_level') {
              let { fieldconfig = {} } = row.currField
              row.options = this.LevelOption(row.options, fieldconfig)
            }
            if (row.fieldtype === 'select') {
              row.fieldvalue = undefined
            }
            if (row.fieldtype === 'area') {
              this.$bus.$emit('clearAreaFieldvalue')
            }

            row.validateStatus = this.setValidateStatus(row)

            this.form.setFieldsValue({
              ['fieldkey' + row._id]: row.fieldkey,
              ['typevalue' + row._id]: row.typevalue
            })
            this.form.validateFields(['fieldkey' + row._id, 'typevalue' + row._id])
          }
        }
      }
      this.formData.list.splice(index, 1, row)
      this.$forceUpdate()
    },

    filterOption (input, option = {}) {
      let { componentOptions = {} } = option
      let { children = [] } = componentOptions
      let { text = '' } = children[0]
      return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    handleChangeRelate (value, index, row) {
      row.typevalue = value
      row.currField.disabled = false
      row.validateStatus = false

      if (value === '已填写' || value === '未填写') {
        row.currField.disabled = true
        row.fieldvalue = ''
      } else if (value === '～') {
        row.fieldvalue = {}
      } else {
        row.fieldvalue = ''
      }

      row.currField.fieldvalue = row.fieldvalue
      /* if (row.fieldtype === 'area') {
        this.$bus.$emit('clearAreaFieldvalue')
      } */

      row.validateStatus = this.setValidateStatus(row)

      this.form.setFieldsValue({
        ['typevalue' + row._id]: value
      })
      this.form.validateFields(['typevalue' + row._id])

      this.formData.list.splice(index, 1, row)
      this.$forceUpdate()
    },

    handleChangeItem (val, index, row) {
      row.fieldvalue = val

      row.validateStatus = this.setValidateStatus(row)

      this.formData.list.splice(index, 1, row)
      this.$forceUpdate()
    },

    setFieldValuePlaceholder (row) {
      let { fieldtype = '' } = row
      let placeholder = '请输入'
      switch (fieldtype) {
        case 'text':
        case 'number':
        case 'phone':
        case 'email':
          placeholder = '请输入'
          break
        case 'select_tree':
        case 'checkbox':
        case 'select':
        case 'radio':
        case 'radioinfo_payfor':
        case 'radioinfo_level':
        case 'radioinfo_type':
        case 'radioinfo_followup':
        case 'from':
        case 'timezones': // 时间区间
        case 'datetime':
        case 'followup_remind_time':
        case 'area':
          placeholder = '请选择'
          break
        default:
          placeholder = '请输入'
          break
      }
      return placeholder
    },

    setValidateStatus (row) {
      let { fieldtype = '', fieldvalue, typevalue } = row
      let error = false
      switch (fieldtype) {
        case 'text':
          if (fieldvalue === '') {
            error = true
          }
          break
        case 'number':
          if (typevalue === '～') {
            if (fieldvalue.min === '' || fieldvalue.min === undefined || fieldvalue.max === '' || fieldvalue.max === undefined) {
              error = true
            }
          } else if (fieldvalue === '') {
            error = true
          }
          break
        case 'phone':
        case 'email':
        case 'select_tree':
        case 'checkbox':
          if (!fieldvalue.length) {
            error = true
          }
          break
        case 'select':
        case 'radio':
        case 'radioinfo_payfor':
        case 'radioinfo_level':
        case 'radioinfo_type':
        case 'radioinfo_followup':
        case 'from':
          if (!fieldvalue) {
            error = true
          }
          break
        case 'timezones': // 时间区间
        case 'datetime':
        case 'followup_remind_time':
          if (typevalue === '～') {
            if (fieldvalue.starttime === '' || fieldvalue.endtime === '' || fieldvalue.starttime === undefined || fieldvalue.endtime === undefined) {
              error = true
            }
          } else if (fieldvalue === '') {
            error = true
          }
          break
        case 'area':
          if (!Object.keys(fieldvalue).length) {
            error = true
          }
          break
      }
      if (typevalue === '已填写' || typevalue === '未填写') {
        error = false
      }
      return error
    },

    handleDelItem (index, row) {
      this.formData.list.splice(index, 1)
      this.$forceUpdate()
    },

    handleAdd () {
      let addObj = JSON.parse(JSON.stringify(this.newObj))

      addObj._id = Math.random() * Math.pow(10, 17)
      this.formData.list.push(addObj)
      this.$forceUpdate()
    },

    LevelOption (options, fieldconfig) {
      const { type } = fieldconfig
      let arr = []

      if (type === 1) {
        arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
      } else if (type === 2) {
        arr = ['一星', '二星', '三星', '四星', '五星', '六星', '七星']
      }

      options.forEach((item, index) => {
        arr.forEach((code, i) => {
          if (index === i) {
            item.name = code
          }
        })
      })

      return options
    },

    hide () {
      this.$emit('update:visible', false)
    },

    setResultString (itemField) {
      let fieldvalueStr = ''
      let { fieldtype = '', fieldname = '', fieldvalue = '', typevalue = '', options = [] } = itemField
      let string = ''
      if (typevalue === '已填写' || typevalue === '未填写') {
        string = fieldname + typevalue + ''
      } else {
        if (fieldtype === 'text' || ((fieldtype === 'number' || fieldtype === 'datetime') && typevalue !== '～')) {
          fieldvalueStr = fieldvalue
        } else if (fieldtype === 'number' && typevalue === '～') {
          fieldvalueStr = fieldvalue.min + '-' + fieldvalue.max
        } else if (fieldtype === 'datetime' && typevalue === '～') {
          fieldvalueStr = fieldvalue.starttime + '-' + fieldvalue.endtime
        } else if (fieldtype === 'select' || fieldtype.indexOf('radio') !== -1) {
          let curr = options.find(item => item.id === Number(fieldvalue))
          fieldvalueStr = curr && curr.name
        } else if (fieldtype === 'from') {
          let currId = Object.keys(fieldvalue) && Object.keys(fieldvalue)[0]
          let curr = options.find(item => item.id === Number(currId))
          fieldvalueStr = curr && curr.name
        } else if (fieldtype === 'checkbox') {
          let curr = options.filter(item => {
            if (fieldvalue.find(one => one === item.id)) {
              return item
            }
          })
          fieldvalueStr = curr && curr.map(item => item.name).join(',')
        } else if (fieldtype === 'select_tree') {
          let res = this.getSelectTreeName([], fieldvalue, itemField.currField)
          fieldvalueStr = res && res.map(item => item.name).join(',')
        } else if (fieldtype === 'area') {
          for (let k in fieldvalue) {
            fieldvalueStr += fieldvalue[k]
          }
        } else if (fieldtype === 'phone' || fieldtype === 'email') {
          fieldvalueStr = fieldvalue.join(',')
        }
        string = fieldname + typevalue + fieldvalueStr + ''
      }
      return string
    },

    getSelectTreeName (res, fieldvalue, data) {
      let child = data.child || data.children || data.options
      if (child && child.length) {
        for (let i in child) {
          let item = child[i]
          for (let value of fieldvalue) {
            if (!res.includes(item) && item.id === parseInt(value)) {
              res.push(item)
            }
            this.getSelectTreeName(res, fieldvalue, item)
          }
        }
      }
      return res
    },

    handleOk () {
      let _this = this
      this.form.validateFields((err, values) => {
        if (!err) {
          let fieldvalueErrors = false
          let res = this.formData.list.map(item => {
            let { _id, fieldkey, fieldtype, fieldname, fieldvalue, typevalue } = item
            let string = this.setResultString(item)
            fieldvalueErrors = fieldvalueErrors || this.setValidateStatus(item)

            let value = fieldvalue
            if (fieldtype === 'number' && _this.$toType(fieldvalue) === 'object') {
              value = ['', ''] // min max
              value[0] = fieldvalue.min
              value[1] = fieldvalue.max
            }
            /* if (fieldtype === 'datetime' && _this.$toType(fieldvalue) === 'object') {
              let { starttime = '', endtime = '' } = fieldvalue || {}
              starttime = fieldvalue.starttime.replace(/-/g, '/')
              endtime = fieldvalue.endtime.replace(/-/g, '/')

              value = ['', ''] // starttime endtime
              value[0] = starttime ? parseInt(new Date(starttime).getTime() / 1000) : starttime
              value[1] = endtime ? parseInt(new Date(endtime).getTime() / 1000) : endtime
            } else if (fieldtype === 'datetime' && _this.$toType(fieldvalue) === 'string') {
              fieldvalue = fieldvalue.replace(/-/g, '/')
              value = parseInt(new Date(fieldvalue).getTime() / 1000)
            } */

            return {
              _id,
              fieldkey,
              fieldtype,
              fieldname,
              typevalue,
              fieldvalue: value,
              string: string
            }
          })

          if (!fieldvalueErrors) {
            this.$emit('setTriggerResult', res, this.formData.type)
            this.hide()
          }
        }
      })
    },

    handleCancel () {
      this.form.resetFields()
      this.hide()
    }
  }
}
</script>

<style scoped lang="scss">
.trigger-form .left {
  float: left;
  width: 118px;
  padding-right: 16px;
  color: #666;
  text-align: right;
}
.trigger-form .right {
  padding-left: 118px;
  padding-right: 24px;
}
.list {
  margin-top: 24px;
}
.item ::v-deep {
  .ant-form-item {
    margin-bottom: 0;
  }
  .ant-form-item-label {
    display: none;
  }
  .ant-form-item-control-wrapper {
    padding-left: 0;
  }
}
.item {
  margin-bottom: 24px;
  .fieldkey {
    width: 140px;
    .ant-select {
      width: 100%;
    }
    ::v-deep .ant-select-selection {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  .relate {
    width: 94px;
    ::v-deep .ant-select-selection {
      border-radius: 0;
      border-left: 0;
      border-right: 0;
    }
  }
  .fieldkey, .relate {
    .ant-select {
      width: 100%;
    }
  }
  .value-box ::v-deep {
    .ant-form-item {
      margin-bottom: 0;
    }
    .ant-input, .ant-select, .datetime, .ant-calendar-picker, .select-box {
      width: 280px;
    }
    .ant-calendar-picker {
      width: 280px !important;
    }
    .input-group .ant-input {
      width: 130px;
    }
    .ant-select-selection {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    .ant-input {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
  ::v-deep .explain-btn {
    display: none;
  }
  .del-btn {
    margin-left: 16px;
    font-style: normal;
    line-height: 32px;
  }
}
.add-btn {
  .iconfont {
    margin-right: 5px;
    color: #999;
  }
}
</style>
<style lang="scss">
.trigger-modal {
  .ant-modal-body {
    padding: 32px 0 40px;
  }
}
/* 万能表单 下拉内的忽略选项隐藏 */
.ant-select-dropdown.tigger-condition-select {
  .ant-select-dropdown-menu-item-group-title[title='ignore'] {
    display: none;
  }
}
</style>
